const colorReducer = (state="yellow", action) => {

    switch(action.type){
        case "setColor":
            return{
                ...state, color: action.payload
            }
        default:
            return state
    }
}

export default colorReducer